import React from 'react'
import { connect } from 'react-redux'
import { t } from 'ttag'
import ReactImageFallback from 'react-image-fallback'
import { useParams } from 'react-router-dom'

import { approveFile, findReview } from '../../actions/review/reviewActions'
import Field from '../../components/form/Field'
import ActionButton from '../../components/ActionButton'
import Form from '../../components/form/Form'
import { useInitDispatch, useTitleChange } from '../../util/hooks'

const FileReview = ({ data, fileApprovalRequest, dispatch }) => {
  useTitleChange(t`File Approval`)
  const params = useParams()

  useInitDispatch(findReview(params.reviewId), [params.reviewId])

  const outputForm = () => {
    if (data.result.approvedBy) {
      return <div>Approved By: {data.result.approvedBy}</div>
    }

    return (
      <Form
        model="review.requestFileApprovalForm"
        onSubmit={form => dispatch(approveFile(data.result.id, form))}>
        {form => (
          <div>
            <Field
              id="address"
              label={t`Your Name`}
              required={true}
              model="review.requestFileApprovalForm.approvedBy"
              form={form}
            />
            <Field
              id="comments"
              label={t`Comments`}
              model="review.requestFileApprovalForm.comments"
              type="textarea"
              form={form}
            />
            <div style={{ margin: '20px 0' }}>
              <ActionButton
                loading={fileApprovalRequest.loading}
                error={fileApprovalRequest.error}
                type="submit"
                className="btn btn-success pull-right">
                {t`Approve`}
              </ActionButton>
            </div>
            <br className="clear" />
          </div>
        )}
      </Form>
    )
  }

  console.log(data)

  if (!data.result) {
    return null
  }

  return (
    <div className="container">
      <p>{t`Click on the thumbnail below to download the document.`}</p>

      <div className="text-center">
        <a href={data.result.file.url}>
          <ReactImageFallback
            src={data.result.file.thumbnailUrl}
            fallbackImage="/images/common/file.png"
            initialImage="/images/common/file.png"
            style={{ maxWidth: '90%', maxHeight: '600px' }}
            alt={t`File Preview`}
          />
        </a>
      </div>
      {data.result.requestorComments && (
        <div className="resorts">
          <h4>
            <i className="help"></i> Comments
          </h4>
          {data.result.requestorComments}
        </div>
      )}
      <br />
      <br />
      <div className="with-border">{outputForm()}</div>
    </div>
  )
}

export default connect(
  state => {
    return {
      ...state.review.files,
      fileApprovalRequest: state.review.fileApprovalRequest
    }
  },
  dispatch => {
    return { dispatch }
  }
)(FileReview)
